import { render, staticRenderFns } from "./IconLeftTop3.vue?vue&type=template&id=450188b8&"
import script from "./IconLeftTop3.vue?vue&type=script&lang=js&"
export * from "./IconLeftTop3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('450188b8')) {
      api.createRecord('450188b8', component.options)
    } else {
      api.reload('450188b8', component.options)
    }
    module.hot.accept("./IconLeftTop3.vue?vue&type=template&id=450188b8&", function () {
      api.rerender('450188b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/PopupButtonPositions/IconLeftTop3.vue"
export default component.exports